export const scrollToSlot = (hours: string) => {
	if (hours) {
		document.getElementById(`hour-${hours}`)?.scrollIntoView({
			behavior: 'smooth',
			block: 'center',
		});
	}
};
